import { useState } from "react";
const useTableSelection = (config = {}) => {
  const {
    rowKey = "id",
    type = "checkbox"
  } = config;
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const handleSelect = (record, selected) => {
    const currentKey = record[rowKey];
    if (type === "radio") {
      setSelectedRowKeys(selected ? [currentKey] : []);
      setSelectedRows(selected ? [record] : []);
    } else {
      if (selected) {
        setSelectedRowKeys((keys) => [...keys, currentKey]);
        setSelectedRows((rows) => [...rows, record]);
      } else {
        setSelectedRowKeys((keys) => keys.filter((key) => key !== currentKey));
        setSelectedRows((rows) => rows.filter((row) => row[rowKey] !== currentKey));
      }
    }
  };
  const handleSelectAll = (selected, _selectedRowsInCurrentPage, changeRows) => {
    const changeRowKeys = changeRows.map((row) => row[rowKey]);
    if (selected) {
      const newKeys = [.../* @__PURE__ */ new Set([...selectedRowKeys, ...changeRowKeys])];
      const addedRows = changeRows.filter(
        (changeRow) => !selectedRows.some((existingRow) => existingRow[rowKey] === changeRow[rowKey])
      );
      setSelectedRowKeys(newKeys);
      setSelectedRows((rows) => [...rows, ...addedRows]);
    } else {
      setSelectedRowKeys((keys) => keys.filter((key) => !changeRowKeys.includes(key)));
      setSelectedRows((rows) => rows.filter((row) => !changeRowKeys.includes(row[rowKey])));
    }
  };
  const clearSelection = () => {
    setSelectedRowKeys([]);
    setSelectedRows([]);
  };
  const rowSelection = {
    type,
    selectedRowKeys,
    onSelect: handleSelect,
    onSelectAll: handleSelectAll
  };
  return {
    selectedRowKeys,
    selectedRows,
    setSelectedRowKeys,
    setSelectedRows,
    clearSelection,
    rowSelection
  };
};
var useTableSelection_default = useTableSelection;
export {
  useTableSelection_default as default
};
